import React from "react";
import { Box } from "@mui/material";
import PdfViewer from "../../../../../components/PdfViewer/PdfViewer";
import {
  getAuditPlanViewerUrl,
  isAuditPlanPdfViewable,
} from "../../utils/auditPlanFileUtils";

const VIEWER_HEIGHT = "min(800px, calc(100vh - 280px))";

const viewerShellSx = {
  width: "100%",
  height: VIEWER_HEIGHT,
  maxHeight: VIEWER_HEIGHT,
  minHeight: "500px",
  borderRadius: "8px",
  border: "1px solid #E5E7EB",
  backgroundColor: "#FFFFFF",
  p: 0,
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
  boxSizing: "border-box",
};

const viewerInnerSx = {
  flex: 1,
  minHeight: 0,
  minWidth: 0,
  width: "100%",
  height: "100%",
  display: "flex",
  alignItems: "stretch",
  justifyContent: "center",
  overflow: "hidden",
};

const AuditPlanFilePreview = ({ file }) => {
  if (!file?.path || !isAuditPlanPdfViewable(file.path)) return null;

  const viewerUrl = getAuditPlanViewerUrl(file.path);

  return (
    <Box sx={viewerShellSx}>
      <Box sx={viewerInnerSx}>
        <Box sx={{ flex: 1, minHeight: 0, width: "100%", display: "flex" }}>
          <PdfViewer fileUrl={viewerUrl} fillHeight />
        </Box>
      </Box>
    </Box>
  );
};

export default AuditPlanFilePreview;
